import ReactDOM from 'react-dom/client'
// https://tailwindcss.com/docs
import './styles/tailwind.css'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'
import '@penguin/components/dist/index.css'
import App from './App'
import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { initWechat } from '@/utils'

// 初始化微信分享
initWechat()

// eslint-disable-next-line
ReactDOM.createRoot(document.getElementById('root')!).render(
  <Router>
    <App />
  </Router>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister()
